import { UUID } from "crypto";

/**
 * Buying patterns query key factory
 */
export const buyingPatternsKeys = {
  all: ["buyingPatterns"] as const,
  // Partner asks
  partnerAsks: (partnerId: UUID) =>
    [...buyingPatternsKeys.all, "asks", partnerId] as const,
  // Product mappings for an ask
  askProducts: (askId: UUID) =>
    [...buyingPatternsKeys.all, "products", askId] as const,
} as const;
